{
  "info": "Teave",
  "negative": "Tõrge",
  "notice": "Hoiatus",
  "positive": "Valmis"
}
